import * as React from "react";
const SvgFiRrMonkey = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-monkey_svg__a)">
      <path
        fill="#062147"
        d="M22 3.5q-.186 0-.364.034A5.51 5.51 0 0 0 16.5 0a5.51 5.51 0 0 0-5.136 3.534 2 2 0 1 0 0 3.932 5.5 5.5 0 0 0 1.206 1.877c-5.968 1.488-8.105 7.498-8.499 11.706A5 5 0 0 1 2 17V6c0-2.467 1.533-4 4-4a1 1 0 0 0 0-2C2.411 0 0 2.411 0 6v11c0 3.86 3.14 7 7 7h14a1 1 0 1 0 0-2h-1V10a1 1 0 0 0-.029-.237 5.5 5.5 0 0 0 1.665-2.296q.177.034.364.034A2 2 0 1 0 22 3.5M15 22v-4.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5V22zm3-11v3.338a3.504 3.504 0 0 0-5 3.162V22H7q-.502 0-.978-.096C6.168 19.521 7.269 11 15.5 11zm-1.5-2C14.57 9 13 7.43 13 5.5S14.57 2 16.5 2 20 3.57 20 5.5 18.43 9 16.5 9"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-monkey_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMonkey;
